<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="grey darken-3"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Emaillogs") }}
        </div>
      </template>
      <div class="text-right">
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="showItem(item)">
            mdi-eye
          </v-icon>
        </template></v-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";

export default {
  name: "app-emailLogs-list",
  data() {
    return {
      loading: true,
      options: {},
      total: 0,
      search: "",
      items: [],
      currentRequestId: 0,
    };
  },
  computed: {
    headers() {
      return [
        { text: "", value: "action", sortable: false },
        {
          text: this.$t("email_to"),
          align: "left",
          value: "to"
        },
        {
          text: this.$t("email_sent_at"),
          align: "left",
          value: "created_at"
        },
        {
          text: this.$t("email_subject"),
          align: "left",
          value: "subject"
        }

      ]
    }
  },
  created() {
    this.getData();
  },

  methods: {
    async getData() {
      this.currentRequestId++;
      const requestId = this.currentRequestId;

      this.loading = true;
      let response = await fetchItems({ ...this.options, search: this.search });
      if (requestId === this.currentRequestId) { 
        this.items = response.data;
        this.total = response.meta.total;
        this.loading = false;
      }
    },
    showItem(item) {
      let url = item.id;
      this.$router.push({ name: "emailLogs.show", params: { id: url } });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler: _.debounce(function () {
        this.getData();
      }, 300), // 300ms debounce delay
      immediate: false,
    },
  }
};
</script>

<style lang="scss" scoped></style>
